// extracted by mini-css-extract-plugin
module.exports = {"statusCard":"statusCard___1iJxL","kanbanPopup":"kanbanPopup___GopHL"};